$(document).ready(function () {
  $('#navigation a').click(function () {
    var t = $(this);
    return (
      $('html, body')
        .stop()
        .animate({scrollTop: $(t.attr('href')).offset().top}, 500),
      !1
    );
  }),
    $(window)
      .scroll(function () {
        var t = $('section'),
          o = $('li');
        t.each(function () {
          var e = $(this),
            i = e.index();
          e.offset().top - $(window).height() / 2 < $(window).scrollTop() &&
          e.offset().top + e.outerHeight() - $(window).height() / 2 > $(window).scrollTop()
            ? o.eq(i - 1).addClass('selected')
            : o.eq(i - 1).removeClass('selected');
        });
      })
      .scroll();
});
